import { Flex, Modal, Typography, Button, Tooltip } from 'antd'
import React, { useState } from 'react'
import RequestClientContact from '../../components/MyOrderActions/RequestClientContact';
import { SolutionOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { Handshake, MessagesSquare, UserRoundPlus } from 'lucide-react';


const RequestClientContactModal = () => {
  const { Title } = Typography;

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalKey, setModalKey] = useState(0);

  const openContactModal = () => {
    setIsModalVisible(true);
    setModalKey((prevKey) => prevKey + 1);
  }

  const closeContactModal = () => {
    setIsModalVisible(false);
  }


  return (
    <>
      <style>{`
  // @keyframes tilt {
  //   0%   { transform: rotate(0deg); }
  //   20%  { transform: rotate(-18deg); }
  //   40%  { transform: rotate(18deg); }
  //   60%  { transform: rotate(-18deg); }
  //   80%  { transform: rotate(18deg); }
  //   100% { transform: rotate(0deg); }
  // }
  @keyframes bg-color-change {
    0%   { background-color: #4CAF50; } /* Green */
    25%  { background-color: #2196F3; } /* Blue */
    50%  { background-color: #FFC107; } /* Yellow */
    75%  { background-color: #2196F3; } /* Blue */
    100% { background-color: #4CAF50; } /* Green */
  }
  @keyframes pulse-glow {
    0% { box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.6); } /* Green glow */
    70% { box-shadow: 0 0 36px 24px rgba(76, 175, 80, 0); }
    100% { box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.6); }
  }
  @keyframes bounce-in {
    0% { transform: scale(0.7); opacity: 0; }
    60% { transform: scale(1.15); opacity: 1; }
    80% { transform: scale(0.95); }
    100% { transform: scale(1); }
  }
  @keyframes border-gradient {
    0% { border-color: #4CAF50; }   /* Green */
    33% { border-color: #2196F3; }  /* Blue */
    66% { border-color: #FFC107; }  /* Yellow */
    100% { border-color: #4CAF50; } /* Green */
  }
  .attention-cta {
    animation: tilt 2s ease-in-out infinite, bg-color-change 8s ease-in-out infinite, pulse-glow 2.5s infinite, bounce-in 0.8s cubic-bezier(.68,-0.55,.27,1.55) 1;
    // border: 3px solid #4CAF50 !important;
    animation-name: tilt, bg-color-change, pulse-glow, bounce-in, border-gradient;
    animation-duration: 2s, 8s, 2.5s, 0.8s, 5s;
    animation-iteration-count: infinite, infinite, infinite, 1, infinite;
    animation-timing-function: ease-in-out, ease-in-out, ease-in-out, cubic-bezier(.68,-0.55,.27,1.55), linear;
    will-change: transform, background-color, box-shadow, border-color;
    display: inline-block;
    color: white;
    outline: none;
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.6);
    transition: background 0.3s, box-shadow 0.3s, border-color 0.3s;
    position: relative;
    z-index: 1;
  }
  .attention-cta:hover {
    animation-play-state: paused;
    box-shadow: 0 0 36px 24px rgba(76, 175, 80, 0.6);
    cursor: pointer;
    background-color: #4CAF50 !important;
    border-color: #4CAF50 !important;
  }
`}</style>

      <Tooltip placement="left" title="Request client contact">
        <Button
          className="attention-cta"
          type="primary"
          icon={
            <MessagesSquare
              size={20}
              className="text-primary cursor-pointer hover:scale-110 transition-transform" />
          }
          shape="circle"
          size="large"
          onClick={openContactModal}
          tabIndex={0}
          aria-label="Request client contact"
        />
      </Tooltip>


      <Modal
        maskClosable={false}
        key={modalKey}
        className="custom-modal"
        title={
          <div className="custom-modal-header">
            <Title
              style={{
                color: "white",
                marginLeft: "15px",
                position: "relative",
                fontSize: "clamp(14px, 3vw, 20px)",
                top: "-5px",
                padding: "0px",
              }}>
              Request Client Contact
            </Title>
          </div>
        }
        onCancel={closeContactModal}
        okText="Submit"
        open={isModalVisible}
        footer={null}
        width={900}>
        <div
          style={{
            maxHeight: "500px",
            overflowX: "hidden",
            overflowY: "auto",
          }}>
          <RequestClientContact handlecloseModal={closeContactModal} />
        </div>
      </Modal>
    </>

  )
}

export default RequestClientContactModal